<template>
  <base-section
    id="hotellet"
  >
    <base-section-heading title="Hotellet som inte brann upp (eller ner)" subtitle="September 2026">
    <base-img
            max-width="100%"
            :src="require(`@/assets/hotellet.png`)"
      />

      <v-container>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          md="12"
          align="center"
        >
        <div class="text-center">
            <base-btn
              :tile="false"
              color="primary"
              href="https://kulturbiljetter.se/evenemang/8938/hotellet-som-inte-brann-upp-eller-ner"
              rounded
            >
              KÖP Biljetter

              <v-icon right>
                mdi-ticket-outline
              </v-icon>
            </base-btn>
          </div>
          <p></p>
          <h2>Om pjäsen</h2>
        <p>Nu följer vi upp förra årets succé <i>Liket på fiket</i> med ännu en hisnande revy-liknande komedi, <i>Hotellet som inte brann upp (eller ner)</i>. 
          En sommarjobbare på traktens hotell får sig en upplevelse hon sent ska glömma. Hon måste hantera sin originella chef samtidigt som hotellet blir plats 
          för ett bröllop, en polisutredning och en urflippad företagskonferens. Humoristisk föreställning med sång och musik.
        </p>
          <h2>Om upplevelsen</h2>
          I pauserna serveras publiken med middag och det finns möjlighet att köpa öl eller vin till maten.
        <p><b>Perfekt sätt att umgås för kompisgänget, kollegorna, after-work etc!</b></p>
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          md="12"
          align="center"
        >
        <p>Spelades på Stadsmissionens Café i Linköping under <b>april och maj</b>. Nästa föreställning är planerad till 19 september på Bron Salonger & Scen (Harrys) i Norrköping.</p>

        <p>Föreställningen börjar kl 18.00. Föreställningens längd är ca 3h inklusive matpauser.
        </p>

        <div class="text-center">
            <base-btn
              :tile="false"
              color="primary"
              href="https://maps.app.goo.gl/6SNW19J2Md5DwsNf8"
              rounded
            >
              HITTA DIT

              <v-icon right>
                mdi-map-marker
              </v-icon>
            </base-btn>
          </div>
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          md="12"
          align="center"
        >
        <p>Under kvällens gång kommer ni att serveras middag: </p>
        <h2>Kvällens meny</h2>
        <h3>Varmrätt</h3>
        <p>Alt. 1 Ugnsbakad kycklingbröstfilé, potatisterrin, haricot vertes och pepparsås.<br/>Alt. 2 Helstekt ryggbiff istället för kyckling</p>
        <h3>Efterrätt</h3>
        <p>Len och krämig pistagemousse, krispiga pistagenötter och ett täcke av choklad.</p>
        <p>Det finns självklart vegetariskt alternativ, var vänlig lämna ett meddelande om det önskas när du köper biljetter.</p>
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          md="12"
          align="center"
        >
        <h2>Om oss</h2>
        <h3>Medverkande</h3>
        <p><b>På scenen:</b> Edith Bergström, Kerstin Bergström, Joakim Carlsson, Lisa Eriksson, Lisa Ferm, Johan Millving och Svante Petré</p>

         

        <p><b>Regi:</b> Fredrik Lundin Zeijlon</p>
        <p><b>Produktion:</b> AB Surdum & Johker Scenkonst AB</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col
            cols="12"
            sm="3"
            md="3"
            align="center">
        <base-img
              width=200
              :src="require(`@/assets/Small_edith.png`)"/>
        <base-info-card
              align="center" 
              v-bind="cards[0]"></base-info-card>
        </v-col>
        <v-col
            cols="12"
            sm="3"
            md="3"
            align="center">
        <base-img
              width=200
              :src="require(`@/assets/Small_kerstin.png`)"/>
        <base-info-card
              align="center" 
              v-bind="cards[1]">
        </base-info-card>
        </v-col>
        <v-col
            cols="12"
            sm="3"
            md="3"
            align="center">
        <base-img
              width=200
              :src="require(`@/assets/Small_jocke.png`)"/>
        <base-info-card
              align="center" 
              v-bind="cards[2]">
        </base-info-card>
        </v-col>
        <v-col
            cols="12"
            sm="3"
            md="3"
            align="center">
        <base-img
              width=200
              :src="require(`@/assets/Small_lisae.png`)"/>
        <base-info-card
              align="center" 
              v-bind="cards[3]">
        </base-info-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
            cols="12"
            sm="3"
            md="3"
            align="center">
        <base-img
              width=200
              :src="require(`@/assets/Small_ferm.png`)"/>
        <base-info-card
              align="center" 
              v-bind="cards[4]"></base-info-card>
        </v-col>
        <v-col
            cols="12"
            sm="3"
            md="3"
            align="center">
        <base-img
              width=200
              :src="require(`@/assets/Small_johan.png`)"/>
        <base-info-card
              align="center" 
              v-bind="cards[5]">
        </base-info-card>
        </v-col>
        <v-col
            cols="12"
            sm="3"
            md="3"
            align="center">
        <base-img
              width=200
              :src="require(`@/assets/Small_svante.png`)"/>
        <base-info-card
              align="center" 
              v-bind="cards[6]">
        </base-info-card>
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          md="12"
          align="center"
        >
        <div class="text-center">
            <base-btn
              :tile="false"
              color="primary"
              href="https://kulturbiljetter.se/evenemang/8938/hotellet-som-inte-brann-upp-eller-ner"
              rounded
            >
              KÖP Biljetter

              <v-icon right>
                mdi-ticket-outline
              </v-icon>
            </base-btn>
          </div>
        <p><b>OBS! Endast förköp! Biljettkassan stänger några dagar före föreställningen!</b></p>
        <p>Har du frågor, skicka ett mail till <a href="mailto:info@johker.se">info@johker.se</a></p>
        </v-col>
      </v-row>
      </v-container>

    </base-section-heading>

  </base-section>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    data: () => ({
      cards: [
        {
          title: 'Edith Bergström',
          text: '',
        },
        {
          title: 'Kerstin Bergström',
          text: '',
        },
        {
          title: 'Joakim Carlsson',
          text: '',
        },
        {
          title: 'Lisa Eriksson',
          text: '',
        },
        {
          title: 'Lisa Ferm',
          text: '',
        },
        {
          title: 'Johan Millving',
          text: '',
        },
        {
          title: 'Svante Petré',
          text: '',
        },
      ],
    }),
  }
</script>
